import Modal from "react-bootstrap/Modal";
import {useRef} from "react";
import axiApi from "ApiCaller";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useTranslation} from "react-i18next";
import Form from "react-bootstrap/Form";
import {SwalAlertClass} from "core/swalClass";

const ModalModMassiveMooch = ({show, setShow, items, setItemsShow}) => {
    const {t: _Tf} = useTranslation("forms");
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    const formModalRef = useRef(null);
    const handleClose = () => {
        setShow(false);
    };

    const onSummit = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        const formData = new FormData(formModalRef.current);
        const ids = items.current.chosen;

        const DataSend = {
            cleared: formData.get("cleared"),
            ids: ids,
        };

        try {
            const resp = await axiApi.post(`/api/distribution/routes/mooch/massive/`, DataSend);
            if (resp.data.status) {
                const clearedBool = DataSend.cleared === "true";
                const total = items.current.chosen.length;
                const updated = resp.data.updated || 0;
                items.current.chosen.forEach((id) => {
                    const item = items.current.showed.find((item) => item.id === id);
                    if (item) {
                        item.cleared = clearedBool;
                    }
                });
                setItemsShow([...items.current.showed]);
                items.current.reset();
                setShow(false);
                if (updated < total) {
                    Alert.warning(
                        "Atención",
                        `Se actualizaron ${updated} de ${total} bolseos. Los que están asignados a una ruta no se pueden modificar.`,
                    );
                } else {
                    Alert.success(_Tf("labels.success"), _Tf("success.title"));
                }
            } else {
                Alert.error(_Tf("labels.error"));
            }
        } catch (error) {
            const msg = error.response?.data?.message || "Error al enviar la solicitud";
            Alert.error("Error", msg);
        }
    };

    return (
        <>
            <Modal show={show} onHide={handleClose} animation={true}>
                <Modal.Header closeButton className="preview-canvas mb-0">
                    <div className="preview-icon">
                        <FontAwesomeIcon icon="dumpster" />
                    </div>
                    <div className="preview-title">
                        <Modal.Title className="d-inline">Modificación Masiva</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <p className="h5 text-center mb-4">Se han seleccionado {items.current.chosen.length} bolseos.</p>
                    <form className="ms-auto" ref={formModalRef}>
                        <div className="row d-flex justify-content-center">
                            <div className="col-3 text-end">
                                <label htmlFor="modMass-cleared" className="col-form-label">
                                    Limpieza
                                </label>
                            </div>
                            <div className="col-9">
                                <Form.Select className="mb-2" id="modMass-cleared" name="cleared" style={{maxWidth: "130px"}}>
                                    <option value="false">Pendiente</option>
                                    <option value="true">Limpio</option>
                                </Form.Select>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={handleClose}>
                        Cancelar
                    </button>
                    <button type="button" className="btn btn-primary" onClick={onSummit}>
                        Aceptar
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ModalModMassiveMooch;
